.modal {
  width: 740px;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 74px;
  height: 74px;
  border-radius: 500%;
  background-color: var(--sentiment-text-info);
  color: var(--static-background-standard);
}

.heading {
  font-size: var(--fs-heading);
}

.body {
  padding: 0 42px 14px;
}

.dontShowAgain {
  margin-right: 20px;
}

.footer {
  display: flex;
  align-items: center;
  gap: 8px;
}
